import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../../../../services/service";
import API_ROUTES from "../../../../api-routes";
import API_ROUTES_V2 from "../../../../api-routes-v2";
import { z } from "zod";
const initialState = {
  isLoading: false,
  success: false,
  error: null,
  useraccess: [],
  allTenantData: [],
  service_url_override: [],
  payslip_portal_link: null,
  loadingstatus: "",
};

export const sendInvites = createAsyncThunk(
  "/user-management/users/invite",
  async (payload, thunkAPI) => {
    try {
      return await apiService("/user-management/users/invite", "POST", {
        payload,
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const getUserRoles = createAsyncThunk(
  "inviteusers/getUserRoles",
  async (payload, thunkAPI) => {
    try {
      return await apiService("/user-management/users/user-roles", "GET");
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const getWorkOsUserById = createAsyncThunk(
  "inviteusers/getWorkOsUserById",
  async (arg, thunkAPI) => {
    try {
      const id = typeof arg === "object" ? arg.id : arg;
      const skipCache = typeof arg === "object" ? arg.skipCache : false;
      return await apiService(API_ROUTES.FETCH_WORKOS_USER, "GET", {
        replace: { id },
        skipCache,
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
export const addEntityAcess = createAsyncThunk(
  "inviteusers/addEntityAcess",
  async (payload, thunkAPI) => {
    try {
      const id = payload?.id;
      return await apiService(API_ROUTES_V2.ADD_USER_ENTITY_ACCESS, "PUT", {
        replace: { id },
        body: payload,
        schema: z.object({
          id: z.string().uuid(),
          access: z
            .array(
              z.object({
                entity_id: z.string().uuid(),
                services: z.array(z.string()),
              }),
            )
            .optional(),
          lsp_id: z.string().optional(),
          timezone: z.string().optional(),
        }),
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const getEntityAcess = createAsyncThunk(
  "inviteusers/getEntityAcess",
  async (arg, thunkAPI) => {
    try {
      const id = typeof arg === "object" ? arg.id : arg;
      const skipCache = typeof arg === "object" ? arg.skipCache : false;
      return await apiService(API_ROUTES_V2.FETCH_USER_ENTITY_ACCESS, "GET", {
        replace: { id },
        skipCache,
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const removeEntityAcess = createAsyncThunk(
  "inviteusers/removeEntityAcess",
  async (payload, thunkAPI) => {
    try {
      return await apiService(
        API_ROUTES_V2.REMOVE_USER_ENTITY_ACCESS,
        "DELETE",
        {
          body: {
            entity_id: payload.entity_id,
          },
          replace: { id: payload.id },
        },
      );
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

const inviteModalSlice = createSlice({
  name: "inviteusers",
  initialState,
  reducers: {
    setUserData: (state, { payload }) => {
      state[payload.key] = payload.value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendInvites.pending, (state) => {
        state.isLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendInvites.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.success = true;
        state.data = payload;
      })
      .addCase(sendInvites.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.success = false;
        state.error = payload;
      })
      .addCase(getUserRoles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserRoles.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.userroles = payload.data;
      })
      .addCase(getUserRoles.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getWorkOsUserById.pending, () => {})
      .addCase(getWorkOsUserById.fulfilled, (state, { payload }) => {
        state.workosuser = payload.data;
      })
      .addCase(getWorkOsUserById.rejected, () => {})

      .addCase(addEntityAcess.pending, (state) => {
        state.loadingstatus = "addaccessloading";
        state.isLoading = true;
      })
      .addCase(addEntityAcess.fulfilled, (state, { payload }) => {
        state.userentity = payload.data;
        state.loadingstatus = "addaccesssuccess";
        state.isLoading = false;
      })
      .addCase(addEntityAcess.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getEntityAcess.pending, () => {})
      .addCase(getEntityAcess.fulfilled, (state, { payload }) => {
        state.useraccess = payload?.data?.access;
        state.allTenantData = payload?.data?.allTenantData || [];
        // Support both new (lsp_tenant) and legacy (lsp_id) field names
        state.userlsp = payload?.data?.lsp_tenant || payload?.data?.lsp_id;
        // GXM-1744: New simple payslip_portal_link field
        state.payslip_portal_link = payload?.data?.payslip_portal_link || null;
        // DEPRECATED: kept for backward compatibility
        state.service_url_override = payload?.data?.service_url_override || [];
        state.loadingstatus = "";
      })
      .addCase(getEntityAcess.rejected, () => {})

      .addCase(removeEntityAcess.pending, (state) => {
        state.loadingstatus = "removeaccessloading";
      })
      .addCase(removeEntityAcess.fulfilled, (state) => {
        state.loadingstatus = "removeaccesssuccess";
      })
      .addCase(removeEntityAcess.rejected, () => {});
  },
});

export const { setUserData } = inviteModalSlice.actions;
export default inviteModalSlice.reducer;
